export const validateContent = (value) => {
    const contentNoHTML = value?.replace(/<[^>]*>/g, '').trim();
    return contentNoHTML === '';
  };